import Image from "./Image"

export default function Birthday() {
    return (
            <>
                <i>
                    <Image
                        src="birthday"
                        alt="birthday"
                    />
                </i>
                <span>30/05/88</span>
            </>
        )
}